import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CredenciaisDTO } from 'src/app/shared/dto/credenciais.dto';
import { Email } from 'src/app/shared/dto/email.dto';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @Input() themeLogo: string = 'assets/images/icon/logo.png' // Default Logo
  @ViewChild('recuperarModal', { static: false }) recuperarModal;
  
  [x: string]: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    public auth: AuthService,
    private fb: FormBuilder,
    private modalService: NgbModal
  ) { }

  public email: string;
  public senha: string;

  public recuperar;

  loginform = true;
  recoverform = false;

  creds;

  ngOnInit() {
    if (localStorage.getItem("atualizar") == null || localStorage.getItem("atualizar") == "1") {
      fetch(location.href, { cache: 'reload' })
        .then(() => {
          location.reload();
        });
        localStorage.setItem("atualizar", "2");
    }
  }

  showRecoverForm() {
    this.loginform = !this.loginform;
    this.recoverform = !this.recoverform;
  }

  loginS() {
    this.creds = new CredenciaisDTO();
    this.creds.email = this.email;
    this.creds.senha = this.senha;

    this.auth.authenticate(this.creds).subscribe(response => {
      this.auth.successfullLogin(response.headers.get('Authorization'));
      this.router.navigate(['/shop/collection/no/sidebar']);
    },
      error => {
        alert("Senha e/ou Login não estão corretos")
      })
  }

  recuperarSenha(){
    this.modalService.open(this.recuperarModal, {
      size: 'md',
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      backdrop: 'static'
    });
  }

  novaSenha() {
    this.emailRecuperar = new Email();
    this.emailRecuperar.email = this.recuperar;
    this.auth.novaSenha(this.emailRecuperar);
    window.location.reload();
  }

}
